import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { backendUrl, API_KEYS } from '../config';

const API_URL = backendUrl;
const axiosConfig = {
  headers: {
    "x-api-key": API_KEYS.key,
    "x-api-secret": API_KEYS.secret
  }
};

// Affichage du nom avec majuscule au début (utilitaire partagé)
function displayAppName(name) {
  if (!name) return '';
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export default function AppGroupApplicationsPage() {
  const { t } = useTranslation();
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [applications, setApplications] = useState([]);
  const [groupApps, setGroupApps] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/app-groups/`, axiosConfig).then(res => {
      setGroups(res.data);
      if (res.data.length > 0) setSelectedGroup(res.data[0].id);
    });
    axios.get(`${API_URL}/applications/`, axiosConfig).then(res => setApplications(res.data));
  }, []);

  useEffect(() => {
    if (selectedGroup) {
      setLoading(true);
      axios.get(`${API_URL}/app-groups/${selectedGroup}/applications`, axiosConfig).then(res => {
        setGroupApps(res.data.map(app => app.id));
        setLoading(false);
      });
    }
  }, [selectedGroup]);

  const handleToggleApp = (appId, checked) => {
    setLoading(true);
    const url = `${API_URL}/app-groups/${selectedGroup}/applications/${appId}`;
    const method = checked ? axios.post : axios.delete;
    method(url, null, axiosConfig).then(() => {
      setGroupApps(prev => checked ? [...prev, appId] : prev.filter(id => id !== appId));
      setLoading(false);
    });
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: 24 }}>
      <h2>{t('groups.app.title')}</h2>
      <label>
        {t('groups.app')}:
        <select
          value={selectedGroup || ""}
          onChange={e => setSelectedGroup(Number(e.target.value))}
          disabled={loading}
        >
          {groups.map(g => (
            <option key={g.id} value={g.id}>{displayAppName(g.name)}</option>
          ))}
        </select>
      </label>
      <div style={{ marginTop: 32 }}>
        <h3>{t('groups.app.desc')}</h3>
        {applications.map(app => (
          <div key={app.id} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
            <input
              type="checkbox"
              checked={groupApps.includes(app.id)}
              disabled={loading}
              onChange={e => handleToggleApp(app.id, e.target.checked)}
            />
            <span style={{ marginLeft: 8 }}>{displayAppName(app.name)}</span>
          </div>
        ))}
      </div>
      {loading && <div>{t('groups.app.loading')}</div>}
    </div>
  );
}
